import dayjs from "dayjs-ext";

function csvDownload(that, apex) {
    //let self = this;
    // console.log(that.$refs[`${apex}`].options.xaxis)
    let column1 = that.$refs[`${apex}`].series[0].data;

    const rows = [];
    for (var i = 0; i < column1.length; i++) {
        rows.push(column1[i]);
    }

    let unit = '???'

    if (that.$refs[`${apex}`].options.yaxis[0].title.text) {
        unit = that.$refs[`${apex}`].options.yaxis[0].title.text
    }

    let csvContent = `data:text/csv;charset=utf-8,`;
    csvContent += `data\tunit\r\n${rows.shift().join(',')}\t ${unit}\r\n`;

    rows.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });

    triggerDownload(
        encodeURI(csvContent),
        `${dayjs().format("DD/MM/YYYY HH:mm:ss")}`,
        ".csv"
    );
}

function triggerDownload(href, filename, ext) {
    //let self = this;
    const downloadLink = document.createElement("a");
    downloadLink.href = href;
    downloadLink.download = filename + ext;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

export {
    csvDownload,
    triggerDownload
}